function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3.869 -2.381)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(4.619 3.131)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.721,16.5h15.55a2.221,2.221,0,0,1,2.221,2.221V26.5a2.221,2.221,0,0,1-2.221,2.221H6.721A2.221,2.221,0,0,1,4.5,26.5V18.721A2.221,2.221,0,0,1,6.721,16.5Z",
  transform: "translate(-4.5 -6.503)",
  fill: "none",
  stroke: "#222d3c",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.5,13V8.554a5.554,5.554,0,0,1,11.107,0V13",
  transform: "translate(-6.057 -3)",
  fill: "none",
  stroke: "#222d3c",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,0,2.686,2.466,5.372,0",
  transform: "translate(12.571 15.145) rotate(180)",
  fill: "none",
  stroke: "#222d3c",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,6.659V0",
  transform: "translate(9.885 19.437) rotate(180)",
  fill: "none",
  stroke: "#222d3c",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
})));

var SvgOffice = function SvgOffice(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.493,
    height: 23.715,
    viewBox: "0 0 21.493 23.715",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOffice, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Office.7d18bafc.svg";
export { ForwardRef as ReactComponent };